export default __webpack_public_path__ + "static/media/InfoLogo.a120f6a4.svg";